<template>
  <div class="page-title display-1 font-weight-thin">{{ title }}</div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
